const LANG_PL = 'LANG_PL';
const LANG_EN = 'LANG_EN';

export const langPl = () => ({
    type: LANG_PL
});

export const langEn = () => ({
    type: LANG_EN
});

const initialState = 'pl';

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case LANG_PL:
            return (state = 'pl');
        case LANG_EN:
            return (state = 'en');
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/state/language.js